export default "__VITE_ASSET__770c64d6__"